export const subtitles = {
    "1": {
        "startTime": 39.55,
        "endTime": 45.19,
        "transcript": "Yaa, kitak' Betty, Akiaq wani imumi iinriurteńgullruuten.",
        "translation": "Yes, okay Betty, you were a health aide long ago in Akiak."
    },
    "2": {
        "startTime": 45.195,
        "endTime": 47.37,
        "transcript": "Ciuqliit iinriurtet ilakellruatgen.",
        "translation": "You were part of the first health aides."
    },
    "3": {
        "startTime": 47.37,
        "endTime": 53.14,
        "transcript": "Kitak' tamaani caliarpet ayuqellranek qanemcitqerkut.",
        "translation": "Please tell us what your work was like back then."
    },
    "4": {
        "startTime": 53.71,
        "endTime": 64.91,
        "transcript": "Tua-i waniw' ayagnillranek ayagniqarraallemnek ayaglua qanemciciqua qaqitenrilengraan.",
        "translation": "Now, I will tell the story of when it started, starting from when I began, even if it's not complete."
    },
    "5": {
        "startTime": 65.425,
        "endTime": 68.745,
        "transcript": "Ayagniqarraallruunga waten:",
        "translation": "I first started like this:"
    },
    "6": {
        "startTime": 69.12,
        "endTime": 77.61,
        "transcript": "Tamaani yuungcarista tekitaqan, iinriurta-llu tekitaqan",
        "translation": "Back then, when the doctor would arrive, and the nurse would arrive"
    },
    "7": {
        "startTime": 79.14,
        "endTime": 88.26,
        "transcript": "Cucuk'laatnga qanerciisqelluteng qanercirluki ayagnilallruunga.",
        "translation": "Since they chose me to speak for them, I'd start by speaking for them."
    },
    "8": {
        "startTime": 88.475,
        "endTime": 95.625,
        "transcript": "Ayagnillruunga, ima-llu-qaa elisngalua.",
        "translation": "I started, and I was knowledgeable."
    },
    "9": {
        "startTime": 95.625,
        "endTime": 101.985,
        "transcript": "Taringenritaqamki-llu qanellrit yugmun egmirteqatarqamki",
        "translation": "And when I didn't understand what they said when I was going to pass on their words to a person."
    },
    "10": {
        "startTime": 102.29,
        "endTime": 110.04,
        "transcript": "Meaning-aarit apqaurluki yuungcarista taringenritaqamku wall'u nurse-aq.",
        "translation": "I asked them about the meaning when I didn't understand the doctor or the nurse."
    },
    "11": {
        "startTime": 110.04,
        "endTime": 117.89,
        "transcript": "Taringaqamku meaning-aara Yugtun taringcuararqamku tua-i egmirtaqluku yugmun.",
        "translation": "When I understood its meaning a little in Yup'ik, I would pass it on to a person."
    },
    "12": {
        "startTime": 119.78,
        "endTime": 131.55,
        "transcript": "Iinrunek-llu ciki'irqatki, igaulluki tua-i, ellaita igaulluki label-aarinun aperturturluki taumun yugmun cikiraqluki.",
        "translation": "And when they gave them medicine, they would right them down, indicating them on their labels, and give it to that person."
    },
    "13": {
        "startTime": 131.88,
        "endTime": 134.83,
        "transcript": "Tua-i tuaten ayagnillruunga.",
        "translation": "That's how I started."
    },
    "14": {
        "startTime": 136.13,
        "endTime": 147.94,
        "transcript": "Waten-llu tekitarkaugaqameng yuungcaristet wall'u iinriurtet",
        "translation": "And when the doctors or nurses planned to arrive"
    },
    "15": {
        "startTime": 147.97,
        "endTime": 150.99,
        "transcript": "Nallunricecaurrlua.",
        "translation": "They started letting me know."
    },
    "16": {
        "startTime": 150.995,
        "endTime": 154.475,
        "transcript": "Tua-i wii elisnganrilama",
        "translation": "Because I wasn't knowledgeable"
    },
    "17": {
        "startTime": 155.65,
        "endTime": 160.85,
        "transcript": "Piyuumiitelqa pissiyaagpek'naku.",
        "translation": "I wouldn't follow my disinclination too much."
    },
    "18": {
        "startTime": 160.855,
        "endTime": 167.335,
        "transcript": "Tau͡gaam tua-i ikayuangnaqu'urluki qanemkun uuggun.",
        "translation": "But I would always try to help them with my speech."
    },
    "19": {
        "startTime": 167.89,
        "endTime": 176.77,
        "transcript": "Tua-i-llu tang piqerluteng wiinga elitnauristet, elitnauristet ullagluki.",
        "translation": "Then one day, I went to the teachers."
    },
    "20": {
        "startTime": 177.035,
        "endTime": 179.625,
        "transcript": "Yuum aqvaaqanga",
        "translation": "When a person came to get me"
    },
    "21": {
        "startTime": 180.865,
        "endTime": 189.935,
        "transcript": "Atra ellirraarluku qanellra pitacirramtun arenqialliqutii igaulluku",
        "translation": "After putting their name, I'd write down what they say their problem was as best as I could"
    },
    "22": {
        "startTime": 190.145,
        "endTime": 197.615,
        "transcript": "Qavcinek-llu ernernek ayagniucia ilait qanernacialaata.",
        "translation": "And how many days it started since some don't say it right away."
    },
    "23": {
        "startTime": 198.215,
        "endTime": 205.945,
        "transcript": "Tua-i iinrumek-llu cali wangnek tunllerkait nalluluki.",
        "translation": "I also didn't know how to give them medicine by myself."
    },
    "24": {
        "startTime": 206.965,
        "endTime": 215.315,
        "transcript": "Tua-i tamakut qanrutkellrenka elitnauristem apiatallerkaa utaqaaqluku.",
        "translation": "About those things I talked about, I'd wait for the teacher's lunch."
    },
    "25": {
        "startTime": 215.575,
        "endTime": 222.335,
        "transcript": "Apiatarqata igaq tauna agutaqluku, tunluku elitnauristeḿun.",
        "translation": "When they had lunch, I'd bring that writing over, and give it to the teacher."
    },
    "26": {
        "startTime": 222.87,
        "endTime": 228.14,
        "transcript": "Qanercuuterutaqlua. Tua-i naaqerraarluki maliklua.",
        "translation": "He would put me on the phone. After I read them, he'd go with me."
    },
    "27": {
        "startTime": 228.14,
        "endTime": 232.74,
        "transcript": "Kiingan qanerrsuutet elitnaurvigmi uitaluteng tamatum nalliini.",
        "translation": "The only phones would be in the school at that time."
    },
    "28": {
        "startTime": 232.745,
        "endTime": 242.775,
        "transcript": "Imkut sugturpat piqarraallret elitnaurviit qamani BIA-mi piullratni.",
        "translation": "Those first very tall ones upriver when they were BIA schools."
    },
    "29": {
        "startTime": 242.925,
        "endTime": 247.975,
        "transcript": "Tua-i elitnaurista report-araqluni yuungcaristeḿun.",
        "translation": "The teacher would report to the doctor."
    },
    "30": {
        "startTime": 248.385,
        "endTime": 259.875,
        "transcript": "Tua-i-llu yuungcaristem yuk tauna cali qanercuutekun qalarucani igauqurluki wii tangvauralaamki.",
        "translation": "Then when the doctor spoke to that person over the phone, he would write them down since I would watch them."
    },
    "31": {
        "startTime": 260.035,
        "endTime": 266.265,
        "transcript": "Elitnauristem igauqurluki qanellri, iinrut-llu tamakut.",
        "translation": "The teacher would write what he said, including those medicine."
    },
    "32": {
        "startTime": 266.395,
        "endTime": 269.215,
        "transcript": "Assirinrilkan-llu cali",
        "translation": "And if he doesn't get better"
    },
    "33": {
        "startTime": 271.33,
        "endTime": 281.26,
        "transcript": "Maavet hospital-aamun tamakut iinrut atulqellrin ikayunrilkatgu taitesqaqluku. Igauqurluki.",
        "translation": "If the medicine he took didn't help him, they'd say to bring him to the hospital here. I wrote these down."
    },
    "34": {
        "startTime": 282.3,
        "endTime": 289.19,
        "transcript": "Tua-i maligtaqulaatnga wiinga caperqenrirluki elitnauristet",
        "translation": "Since they would obey me, I wasn't intimidated by the teachers anymore"
    },
    "35": {
        "startTime": 289.38,
        "endTime": 292.75,
        "transcript": "Uamtengramki nallunailngurmek.",
        "translation": "Though it was clear I was taking up their time."
    },
    "36": {
        "startTime": 293.03,
        "endTime": 299.21,
        "transcript": "Tua-i-ll' qanenriami iinrivigmun ayaullua taum elitnauristem.",
        "translation": "Then when he stopped speaking, that teacher brought me to the clinic."
    },
    "37": {
        "startTime": 300.995,
        "endTime": 306.045,
        "transcript": "Alerqualua tua-i taum yuum atu'urkainek.",
        "translation": "He would instruct me on what that person should do."
    },
    "38": {
        "startTime": 306.045,
        "endTime": 308.495,
        "transcript": "Tua-i tuaten piurluki.",
        "translation": "I would do that with them."
    },
    "39": {
        "startTime": 310.075,
        "endTime": 314.75,
        "transcript": "Tua-i-llu nutaan 1960-mi",
        "translation": "Then in 1960"
    },
    "40": {
        "startTime": 314.75,
        "endTime": 320.26,
        "transcript": "Au͡gna man'a qallatelqa uum 1960-m ciukaa.",
        "translation": "What I talked about was before 1960."
    },
    "41": {
        "startTime": 320.43,
        "endTime": 330.6,
        "transcript": "Nineteen-sixty-mi council-aat teguatnga, quyurrluteng December-aami ilaklua wiinga.",
        "translation": "In 1960, the [tribal] council took me, meeting in December with me."
    },
    "42": {
        "startTime": 330.6,
        "endTime": 333.27,
        "transcript": "Tua-i-ll' tuani",
        "translation": "Then at that time"
    },
    "43": {
        "startTime": 336.3,
        "endTime": 345.33,
        "transcript": "Qanrullua waniwa tegunilua, ikayualaasqelluki waten tekisngalriit.",
        "translation": "They said that they've taken me, and to help those that arrive like this."
    },
    "44": {
        "startTime": 346.32,
        "endTime": 351.77,
        "transcript": "Tua-i qaill' piviilama piyunarqekuma piciqnilua.",
        "translation": "Since I had no choice, I said I would do it if I were able."
    },
    "45": {
        "startTime": 352.14,
        "endTime": 358.8,
        "transcript": "Tua-i tuaken nutaan 1960-mek-am cali au͡gna pellulriatun ayuqluni.",
        "translation": "And since 1960, it was like what was before had passed."
    },
    "46": {
        "startTime": 359.145,
        "endTime": 364.545,
        "transcript": "Nineteen-sixty-mek taqevkenii, tau͡gaam elitnauristet ullagluki.",
        "translation": "I didn't quit in 1960, but I went to the teachers."
    },
    "47": {
        "startTime": 365.91,
        "endTime": 375.96,
        "transcript": "Tua-i-llu cat iliitni elitnaurista au͡gna, cimiraqluteng, cimiraqluteng.",
        "translation": "Then one day, that teacher, they would be replaced, replaced."
    },
    "48": {
        "startTime": 376.04,
        "endTime": 383.0,
        "transcript": "Iliit au͡gna atra nalluyaguteksaitaqa ulla'agqa.",
        "translation": "I went to one of them, whose name I haven't forgotten."
    },
    "49": {
        "startTime": 383.005,
        "endTime": 388.055,
        "transcript": "Tau͡gaam aperturngaitaqa atra. Tua-i elisngaqapigtaqa.",
        "translation": "But I won't say their name. I know it clearly."
    },
    "50": {
        "startTime": 389.345,
        "endTime": 392.825,
        "transcript": "Ulla'agqa. Ciungani ullagaqluku.",
        "translation": "I went to them. I'd go to them in the past."
    },
    "51": {
        "startTime": 393.1,
        "endTime": 396.81,
        "transcript": "Au͡gkutun tang ciuqlirmitun una pivkenani.",
        "translation": "This one wasn't like the others before them."
    },
    "52": {
        "startTime": 396.81,
        "endTime": 401.54,
        "transcript": "Qavcirqunek ullagcetqerluni qanrutaanga ullallemni",
        "translation": "After going to them several times, they told me"
    },
    "53": {
        "startTime": 401.54,
        "endTime": 412.86,
        "transcript": "Waten pianga: ellii-gguq iinriurteńguyarturluni wall'u yuungcaristeńguyarturluni tainrituq Kuigglugmun.",
        "translation": "[S]he said this to me: [s]he didn't come to Kwethluk to be a nurse or a doctor."
    },
    "54": {
        "startTime": 413.185,
        "endTime": 417.245,
        "transcript": "Elitnauriyarturluni-gguq taiguq.",
        "translation": "[S]he said [s]he came to teach."
    },
    "55": {
        "startTime": 417.72,
        "endTime": 420.48,
        "transcript": "Tua-i-ll' piaqa",
        "translation": "Then I said to them"
    },
    "56": {
        "startTime": 420.485,
        "endTime": 432.735,
        "transcript": "\"Tua-i-wa wiinga-llu Kass'at qaneryaraat elisnganrilamku wiinga-ll' elpeceńun ikayuryulalrianga elitnauristeńun ak'anek ciuvnek ayaglua.\"",
        "translation": "\"Since I do not know much about the English language, I also need you teachers' help since way before you.\""
    },
    "57": {
        "startTime": 433.295,
        "endTime": 440.195,
        "transcript": "Tua-ll' pianga, iganka-gguq naaqelarai.",
        "translation": "Then [s]he said that [s]he reads what I write."
    },
    "58": {
        "startTime": 440.6,
        "endTime": 444.32,
        "transcript": "Camek-gguq ayuquciiteksaituq.",
        "translation": "[S]he said that there was nothing confusing."
    },
    "59": {
        "startTime": 444.415,
        "endTime": 452.165,
        "transcript": "Wangnek-gguq report-alarlii imkut amkut aperturluki.",
        "translation": "[S]he said that I should report by myself, briefing them over there."
    },
    "60": {
        "startTime": 452.165,
        "endTime": 455.685,
        "transcript": "Radio-tgun-gguq wangnek report-alarlii.",
        "translation": "[S]he said that I should report on the radio by myself."
    },
    "61": {
        "startTime": 455.91,
        "endTime": 470.588,
        "transcript": "Tua-ll' piaqa, \"Usuuq, wiinga tang waniwa yuurterraanemnek tailrianga ukani kingumni una erneq tekilluku.",
        "translation": "Then I said to them, \"Hey you, since I was born, I have come from all the days before me to this day."
    },
    "62": {
        "startTime": 470.696,
        "endTime": 477.751,
        "transcript": "\"Ataucirquungraan radio-t button-aarat negteksaitaqa.\"",
        "translation": "\"Never once have I pressed the radio's button.\""
    },
    "63": {
        "startTime": 477.829,
        "endTime": 488.874,
        "transcript": "\"Nuu, elitnaurciqamken. Elitnaurciqamken waniwa maliklunuk taglunuk.\"",
        "translation": "\"No, I will teach you. I will teach you if you come with me inland.\""
    },
    "64": {
        "startTime": 488.979,
        "endTime": 491.523,
        "transcript": "Piaqa, \"Piyukuvet.\"",
        "translation": "I said, \"If you want to.\""
    },
    "65": {
        "startTime": 491.538,
        "endTime": 496.682,
        "transcript": "Eniinek anulluku tag'ukuk apiatam nalliinguan.",
        "translation": "I took them out of their house, and we went inland since it was lunch time."
    },
    "66": {
        "startTime": 497.807,
        "endTime": 508.927,
        "transcript": "Tua-i-ll' itramegnuk, imkut tua-i waten pitullratni iciw' sassaunateng, yuungcaristem ikirtellerkaa utaqaluku.",
        "translation": "Then when we went in, when they used to do this, you know, with no clocks, we waited for the doctor to be open."
    },
    "67": {
        "startTime": 509.239,
        "endTime": 517.371,
        "transcript": "Ciumek qanelriim qanellra niitaqamegteggu kiutunganaku tamatum nalliini.",
        "translation": "When they heard the first one speaking, I think they would then answer."
    },
    "68": {
        "startTime": 517.799,
        "endTime": 526.633,
        "transcript": "Tua-i-ll' uum elitnauristem pianga, \"Tangvakia. Tangvlagluten qanerceciiqamken.\"",
        "translation": "Then this teacher said to me, \"Watch me. I will watch you and have you speak.\""
    },
    "69": {
        "startTime": 526.634,
        "endTime": 528.622,
        "transcript": "Angraqa.",
        "translation": "I agreed."
    },
    "70": {
        "startTime": 531.223,
        "endTime": 541.267,
        "transcript": "Tua-i-ll' tua-i imna qayagaurcuun pirraarluku uum qayagaurluki tua-i.",
        "translation": "Then after making the call, [s]he called them."
    },
    "71": {
        "startTime": 542.571,
        "endTime": 547.915,
        "transcript": "Qamna-llu wangnun report-aqniluku qanrutekluku.",
        "translation": "Then [s]he said to them that it was my report."
    },
    "72": {
        "startTime": 548.228,
        "endTime": 555.05,
        "transcript": "Tua-i-ll' aren, tangvagluku eligartenritaqa.",
        "translation": "Then, oh my, I didn't learn right away from watching them."
    },
    "73": {
        "startTime": 555.346,
        "endTime": 563.757,
        "transcript": "Tau͡gaam tua-i una qallatellra, negtellri nalluluki imkullrit piluki.",
        "translation": "But what they said, I didn't know what they pressed."
    },
    "74": {
        "startTime": 567.697,
        "endTime": 571.175,
        "transcript": "Qaqiucami pianga",
        "translation": "When [s]he was finished, [s]he said to me"
    },
    "75": {
        "startTime": 571.466,
        "endTime": 580.677,
        "transcript": "Taum-llu ima tanem iinrut alerquutekai ellirraarluki tua-i yuungcarista qanrucamiu",
        "translation": "And after [s]he put the instructions for the medicine, when [s]he spoke to the doctor"
    },
    "76": {
        "startTime": 580.688,
        "endTime": 584.766,
        "transcript": "Waniwa-gguq wangnun repeat-arcetqatarai qanellri.",
        "translation": "[S]he said [s]he was going to have me repeat what [s]he said."
    },
    "77": {
        "startTime": 585.979,
        "endTime": 591.101,
        "transcript": "Yuungcaristem cangelkenritaa. Pisqaa. Angraa.",
        "translation": "The doctor was fine with it. [S]he told them to do it. [S]he agreed."
    },
    "78": {
        "startTime": 592.79,
        "endTime": 600.257,
        "transcript": "Tua-i-ll' wangnun taicaku",
        "translation": "Then when [s]he brought it to me"
    },
    "79": {
        "startTime": 601.25,
        "endTime": 611.917,
        "transcript": "Ayaumiin umeksailan taicaku, taicamiu pianga, \"Kitak' au͡gna qanrutkesqelluku,\" tua-i-ll' niicugniciqnilua.",
        "translation": "Since it was still going and [s]he gave it to me, [s]he said to me, \"Now, talk about that,\" then that [s]he would listen to me."
    },
    "80": {
        "startTime": 612.631,
        "endTime": 615.031,
        "transcript": "Ciuqamni uitaluni.",
        "translation": "[S]he was in front of me."
    },
    "81": {
        "startTime": 615.855,
        "endTime": 621.899,
        "transcript": "Tua-i-llu qanellri tua-i niitniluki.",
        "translation": "Then I said I heard what [s]he said."
    },
    "82": {
        "startTime": 621.907,
        "endTime": 629.84,
        "transcript": "Uum patient-aam alerquutai-llu iinrukai-llu niitniluki.",
        "translation": "And I said I heard what the patient needs to do, and their medicine."
    },
    "83": {
        "startTime": 629.847,
        "endTime": 632.525,
        "transcript": "\"Tua-i-qaa assirlua niitamken?\"",
        "translation": "\"Did I hear you right?\""
    },
    "84": {
        "startTime": 632.739,
        "endTime": 644.117,
        "transcript": "Iciw' over-aarciiganii-llu wii. Over-aaneq nalluqapiggluku tamatum nalliini over-aatullratni.",
        "translation": "You know, I couldn't say \"over\" either. I didn't know how to say \"over\" at that time when they used to say \"over.\""
    },
    "85": {
        "startTime": 646.408,
        "endTime": 653.385,
        "transcript": "Aren, assirtuq-gguq. Assirtuq-gguq. Assirlua-gguq taringaqa.",
        "translation": "Oh my, [s]he said it's good. [S]he said it's good. [S]he said I understood it well."
    },
    "86": {
        "startTime": 655.059,
        "endTime": 665.267,
        "transcript": "Tua-i-llu taqngamku tua-i taum elitnauristem pianga",
        "translation": "Then when I was done with it, that teacher said to me"
    },
    "87": {
        "startTime": 665.49,
        "endTime": 674.479,
        "transcript": "Waniwa-gguq waken ayaglua wangnek qayagaularciqua.",
        "translation": "[S]he said that from then on, I would call by myself."
    },
    "88": {
        "startTime": 674.989,
        "endTime": 682.122,
        "transcript": "Piaqa, \"Unuaqu kiima qayagaurngaitua. Maligciiqerpenga.\" Maligciiqaanga-gguq.",
        "translation": "I said, \"I won't call by myself tomorrow. You'll go with me.\" [S]he said [s]he'd go with me."
    },
    "89": {
        "startTime": 682.672,
        "endTime": 692.416,
        "transcript": "Tua-i-llu-am tua-i apiataurcan ullagluku, taum tua-i patient-aam taukut pii avaliqluki",
        "translation": "Then when it was lunch time, I went to the, bringing with me that patient's things"
    },
    "90": {
        "startTime": 692.427,
        "endTime": 699.905,
        "transcript": "Aqvaaqatnga waten igauqurluki pilallruamki pitacirramtun tua-i.",
        "translation": "Because when they got me, I'd write them down as best as I could."
    },
    "91": {
        "startTime": 699.917,
        "endTime": 707.261,
        "transcript": "Tua-i-llam ulliimni pianga, \"Tua-i-mtaq qanercuuteqatartuten?\"",
        "translation": "Then when I went to them, [s]he said to me, \"Are you going to make the call?\""
    },
    "92": {
        "startTime": 707.275,
        "endTime": 709.698,
        "transcript": "Angerluku tua-i.",
        "translation": "I said yes."
    },
    "93": {
        "startTime": 710.139,
        "endTime": 712.35,
        "transcript": "Kitak'-gguq tua-i...",
        "translation": "[S]he said that I should..."
    },
    "94": {
        "startTime": 714.407,
        "endTime": 723.717,
        "transcript": "Uum-am im' akwaugaq im' pilararkaulua, kitak-gguq taglua qayagauryarturlaku yuungcarista.",
        "translation": "After the previous day, [s]he said that I should go inland and call the doctor."
    },
    "95": {
        "startTime": 723.725,
        "endTime": 729.414,
        "transcript": "Piaqa, \"Maligglua. Elitellrunritaqa negtaallerkaq.\"",
        "translation": "I said to them, \"Come with me. I didn't learn what to press.\""
    },
    "96": {
        "startTime": 729.422,
        "endTime": 735.133,
        "transcript": "Ellimauq-gguq. Iciw' ellirpaumauq igarpak kanani.",
        "translation": "[S]he said it's on there. You know, it's there in big letters down there."
    },
    "97": {
        "startTime": 736.206,
        "endTime": 739.484,
        "transcript": "Tua-i-ll' maliklunuk taglunuk.",
        "translation": "Then we went inland together."
    },
    "98": {
        "startTime": 739.586,
        "endTime": 747.82,
        "transcript": "Tua-i-ll' pianga itramegnuk taukut tua-i negtaarraarluki naaqesqelluki ukut.",
        "translation": "Then [s]he said to me when we went in to press these and read these."
    },
    "99": {
        "startTime": 747.822,
        "endTime": 753.844,
        "transcript": "Man'a apertuusqelluku Kuiggluk ellimalaan.",
        "translation": "[S]he said to indicate Kwethluk since it's put there."
    },
    "100": {
        "startTime": 753.853,
        "endTime": 758.397,
        "transcript": "Naaqluki taukut, tangvagluki naaqluki wavet.",
        "translation": "Reading those, I looked at and read those here."
    },
    "101": {
        "startTime": 759.753,
        "endTime": 765.664,
        "transcript": "Ak'aniqanrituq. Tua-i pillangraata nunussiyaagpek'nani kiulua.",
        "translation": "It wasn't long. Though it was sudden, [s]he answered me without scolding too much."
    },
    "102": {
        "startTime": 765.672,
        "endTime": 768.361,
        "transcript": "Tua-i qanrulluku taumek.",
        "translation": "I told them about that."
    },
    "103": {
        "startTime": 768.714,
        "endTime": 777.692,
        "transcript": "Qanruqaarluku, piurallri qanrutkurarraarluki",
        "translation": "After telling them, after saying what [s]he said"
    },
    "104": {
        "startTime": 780.431,
        "endTime": 785.22,
        "transcript": "Iinrunek tamakunek pisqelluku.",
        "translation": "[S]he said that they should take that medicine."
    },
    "105": {
        "startTime": 785.677,
        "endTime": 791.354,
        "transcript": "Tua-i cali igaulluki tangvangraanga taum elitnauristem.",
        "translation": "I also wrote them down though that teacher was watching me."
    },
    "106": {
        "startTime": 791.868,
        "endTime": 795.013,
        "transcript": "Taqngama tua-i taqlua.",
        "translation": "When I was done, I was done."
    },
    "107": {
        "startTime": 796.347,
        "endTime": 807.07,
        "transcript": "Taum-am ik'iki pikilia wangnek-gguq iinrut tangerrluki amani paivcarturlaki.",
        "translation": "[S]he told me to look at the medicine by myself over there and set them out."
    },
    "108": {
        "startTime": 807.081,
        "endTime": 814.514,
        "transcript": "Tangerciqai-gguq atakurpak. Eniitni uitaluni, yuungcaristem eniini.",
        "translation": "[S]he said that [s]he would look at them that evening. [S]he was at their house, at the doctor's house."
    },
    "109": {
        "startTime": 815.115,
        "endTime": 819.648,
        "transcript": "Taukut tau͡gken qanercuutet pamani elitnaurvigmi.",
        "translation": "However, the phone was inland at the school."
    },
    "110": {
        "startTime": 819.835,
        "endTime": 825.613,
        "transcript": "Atam waten nalluluni arenqiatuq.",
        "translation": "You see, it's distressing when one doesn't know like this."
    },
    "111": {
        "startTime": 825.953,
        "endTime": 832.231,
        "transcript": "Imkuuq, alingurnarquq yugnun. Yugnun alingurnarqessaaquq.",
        "translation": "It's, you know, scary for people. It's scary for people."
    },
    "112": {
        "startTime": 832.243,
        "endTime": 842.588,
        "transcript": "Tau͡gaam imutun tua-i eliquralriatun ayuqnaqliniami tua-i maqariinarnganani.",
        "translation": "But since it's like it takes getting used to, it seemed that it became more [?manageable]."
    },
    "113": {
        "startTime": 842.598,
        "endTime": 850.02,
        "transcript": "Ircaquq-llu nutngauciqenrillmenek nutngayuirulluni.",
        "translation": "And what used to make the heart pound doesn't make it pound anymore."
    },
    "114": {
        "startTime": 850.027,
        "endTime": 853.094,
        "transcript": "Cangalliurnanrirluni.",
        "translation": "It isn't bothered anymore."
    },
    "115": {
        "startTime": 855.954,
        "endTime": 863.843,
        "transcript": "Tua-i-llu qavcirqunek maligqaarlua uum kelucanek cikiraanga.",
        "translation": "Then after [s]he went with me several times, [s]he gave me keys."
    },
    "116": {
        "startTime": 863.96,
        "endTime": 873.005,
        "transcript": "Taum pam'um kelucainek, enem-llu iinrut kelucaatnek cikiraanga.",
        "translation": "[S]he gave me keys for [the school] up there, and the clinic's keys."
    },
    "117": {
        "startTime": 873.865,
        "endTime": 882.732,
        "transcript": "Ullanrilnge'rmi wangnek elitnaurvik kelucaumaaqan ikirrluku iterlua qanercuutelaasqellua.",
        "translation": "Even if I didn't go to them when the school is locked, [s]he told me to open it, go in, and use the communication device."
    },
    "118": {
        "startTime": 882.742,
        "endTime": 892.776,
        "transcript": "Cali iinrut pisqaqateki atrarlua qanenrilnge'rma ikirrluku iinrut pilaasqelluki.",
        "translation": "Also, when they said to prepare medicine, [s]he told me to go down, open it without notifying anyone, and prepare the medicine."
    },
    "119": {
        "startTime": 892.788,
        "endTime": 898.076,
        "transcript": "Tua-i tuatnayaurtua training-aarpailegma.",
        "translation": "I started doing that before I went to training."
    },
    "120": {
        "startTime": 899.338,
        "endTime": 907.261,
        "transcript": "Tua-i-ll' nutaan tuatnayaurteqerlua training-aamu eklua.",
        "translation": "Then just when I started doing that, I got into training."
    },
    "121": {
        "startTime": 908.443,
        "endTime": 923.14,
        "transcript": "Nutaan tua-i training-aaryaurcama imkut aturluki piqacaarangnaqu'urlua tua-i tuaten piaqlua.",
        "translation": "When I started training, I would try to do what I had done like that."
    },
    "122": {
        "startTime": 923.149,
        "endTime": 930.205,
        "transcript": "Malruurtellruukuk tau͡gaam ayainanmegni tamaani training-aaqatarluta.",
        "translation": "But we became two as we were going back when we were going to train."
    },
    "123": {
        "startTime": 930.219,
        "endTime": 932.964,
        "transcript": "Malruulunuk waten.",
        "translation": "There were two of us like this."
    },
    "124": {
        "startTime": 935.341,
        "endTime": 943.364,
        "transcript": "Tau͡gaam-am malruulunuk calingengamegnuk neryuunanuk.",
        "translation": "But when the two of us started working, we would eat [lunch]."
    },
    "125": {
        "startTime": 943.37,
        "endTime": 945.867,
        "transcript": "Apiatayuunanuk.",
        "translation": "We wouldn't have lunch."
    },
    "126": {
        "startTime": 945.867,
        "endTime": 958.462,
        "transcript": "Ten kela'agmi ikirtetuluni, yaavet ima tanem camun? Five kela'agmun pilaryugnarquq tamaani piqarraallemegni.",
        "translation": "It would open at 10:00, until when would it go? I think it would be until 5:00 back when we started."
    },
    "127": {
        "startTime": 959.478,
        "endTime": 966.989,
        "transcript": "Apiatayuunanuk elitnaurista elitnauranek taivkarituan",
        "translation": "We wouldn't have lunch because the teacher sent students to us"
    },
    "128": {
        "startTime": 967.96,
        "endTime": 970.671,
        "transcript": "Tua-i yaavet umellranun.",
        "translation": "All the way until it closed."
    },
    "129": {
        "startTime": 970.679,
        "endTime": 977.801,
        "transcript": "Umgem-llu kinguani nutaan yuut aqvaaqatkuk tuavirtaqlunuk.",
        "translation": "And after closing, when people came to get us, we would go there."
    },
    "130": {
        "startTime": 977.813,
        "endTime": 980.636,
        "transcript": "Tuavet ayagaqlunuk.",
        "translation": "We would go there."
    },
    "131": {
        "startTime": 982.753,
        "endTime": 990.397,
        "transcript": "Unuungraan-llu qavamegni iterluteng tupagtaqatekuk tua-i wii-ll' kiima pivkenii.",
        "translation": "And when they came in at night while we were sleeping and woke us up, and I wasn't the only one."
    },
    "132": {
        "startTime": 991.202,
        "endTime": 995.747,
        "transcript": "Tua-i aqvaaqatkuk taumun yugmun ayagaqlunuk.",
        "translation": "When they came to get us, we'd go to that person['s house]."
    },
    "133": {
        "startTime": 995.761,
        "endTime": 1009.573,
        "transcript": "Wiinga-llu tamaani elitnaullma kinguani tuar tang iinrut-llu tunllerkait ancurtukenrilriatun ellirluki nallunaitaralriit.",
        "translation": "And after I trained then, it truly seemed that I was not reserved to even give them medicine [since] it they became clear."
    },
    "134": {
        "startTime": 1009.581,
        "endTime": 1023.27,
        "transcript": "Tau͡gaam imkut taringevlacakaqenka, atrit-llu taringevlacakenka pivkenaki.",
        "translation": "But I would give out what I didn't fully understand, including the names I didn't fully understand."
    },
    "135": {
        "startTime": 1023.284,
        "endTime": 1028.273,
        "transcript": "Yugmun tunyuunaki nalqiguterraarpek'naki.",
        "translation": "I wouldn't give them to a person without explaining them."
    },
    "136": {
        "startTime": 1028.286,
        "endTime": 1032.93,
        "transcript": "Tua-i waten una wavet pitaluku.",
        "translation": "This is it for that [story]."
    },
    "137": {
        "startTime": 1032.939,
        "endTime": 1037.095,
        "transcript": "Au͡gna cali ciunra amllertuq.",
        "translation": "There is a lot before what I just said."
    },
    "138": {
        "startTime": 1037.469,
        "endTime": 1043.502,
        "transcript": "Ayagniqarraallemnek ayaglua wavet training-aallemnun qanertua waten.",
        "translation": "Starting from what I first started to my training, I've spoken about this."
    },
    "139": {
        "startTime": 1044.735,
        "endTime": 1052.913,
        "transcript": "Ava-i qanelriaten wani ayagniqarraallerpeni tua-i camek elitnaurutaunak pillruniluten.",
        "translation": "You just said that when you first started, that you did it without any training."
    },
    "140": {
        "startTime": 1052.931,
        "endTime": 1060.065,
        "transcript": "Qaillun man'a tamana tua-i pingnatullren alerquutiitnek",
        "translation": "How does this pertain to instructions on how to make your own living"
    },
    "141": {
        "startTime": 1060.072,
        "endTime": 1064.372,
        "transcript": "Alerquutiitnun ekumauq, pingnatugluni-gguq yuk pairkauguq.",
        "translation": "It's in their traditional instructions, that a person must make their own living."
    },
    "142": {
        "startTime": 1064.388,
        "endTime": 1071.944,
        "transcript": "Qaillun ayagyuat tamatumun calimun pingnatugyaramun alerquryugngasikut wangkuta?",
        "translation": "What can you instruct to us young poeple about how to work to make your own living like that?"
    },
    "143": {
        "startTime": 1072.616,
        "endTime": 1080.16,
        "transcript": "Atam ava-i qanrutamken waten: \"Wiinga umyuaqa aturluku pingnatugpek'naki",
        "translation": "You see, I told you this: \"I didn't choose to work hard with them on my own"
    },
    "144": {
        "startTime": 1080.172,
        "endTime": 1093.405,
        "transcript": "\"Tau͡gaam tua-i yuungcaristem iinriurtem-llu qanellra egmirrluku, egmirteqtarturluku wii umyuaqa aturluku pingnatugpek'naku\"",
        "translation": "\"But I passed the doctor's and nurse's message, passed it on in my hard work that wasn't my choice.\""
    },
    "145": {
        "startTime": 1094.612,
        "endTime": 1103.879,
        "transcript": "Tuaten pillruunga. Ayagnillruunga avani camek iinrumek auluklerkaanek nallulua.",
        "translation": "That's what I did. I started back then without knowing how to take are of medicine."
    },
    "146": {
        "startTime": 1104.66,
        "endTime": 1114.027,
        "transcript": "Tua-i tau͡gaam elitnaurama tua-i eliteqtara'arlua eliteqtararalqa aturluku piqcaararaqlua.",
        "translation": "But when I  went to training, I would do it according to what I had learned."
    },
    "147": {
        "startTime": 1114.581,
        "endTime": 1124.947,
        "transcript": "Qaillun-mi qitevtelangellrusit, wall'u Kass'atun taringelangellrusit tamaani wani elitnauristet tekitaangvailgata?",
        "translation": "So, how did you learn to to speak English, or how did you learn to how understand English back before teachers came?"
    },
    "148": {
        "startTime": 1124.958,
        "endTime": 1128.403,
        "transcript": "Tamatum-qaa ciungani elitnaullruuten?",
        "translation": "Did you go to school before then?"
    },
    "149": {
        "startTime": 1128.412,
        "endTime": 1132.235,
        "transcript": "Tamatum ciungani elitnaullruunga.",
        "translation": "I went to school before that."
    },
    "150": {
        "startTime": 1132.253,
        "endTime": 1137.342,
        "transcript": "Tau͡gaam waniwa tamaani wiinga igaq elitnaueqerraallemni",
        "translation": "But back when I first learned writing"
    },
    "151": {
        "startTime": 1137.349,
        "endTime": 1146.116,
        "transcript": "Tau͡gaam taqnerurrlua-w' tua-i ellakamnek ellanglua tayima pillilrianga elitnaullrullilrianga.",
        "translation": "But when I became an adult, I think it was when I learned after becoming aware."
    },
    "152": {
        "startTime": 1146.57,
        "endTime": 1150.026,
        "transcript": "What year-aq nalluku.",
        "translation": "I don't know what year."
    },
    "153": {
        "startTime": 1150.04,
        "endTime": 1157.596,
        "transcript": "I can't say what it was to this day, yet I went to school when it was in a building.",
        "translation": "I can't say what it was to this day, yet I went to school when it was in a building."
    },
    "154": {
        "startTime": 1157.603,
        "endTime": 1161.536,
        "transcript": "Elitnaurviuvkenani, enemni tau͡gaa.",
        "translation": "It wasn't a school, but in a house."
    },
    "155": {
        "startTime": 1161.545,
        "endTime": 1167.89,
        "transcript": "Tua-i tamaaken ayagluta elitnaurluta, kiituani elitnaurviliut.",
        "translation": "We started going to school from then, and they eventually built a school."
    },
    "156": {
        "startTime": 1167.902,
        "endTime": 1176.28,
        "transcript": "Tua-i-llu elitnaurvilillratni elitnaurvimta wiinga-llu 5th grade-aq tekilluku taqlua.",
        "translation": "Then when they made schools, in our school, I stopped at the fifth grade."
    },
    "157": {
        "startTime": 1176.309,
        "endTime": 1181.598,
        "transcript": "Tua-i tuaken grade-at fifth grade-aq tekilluku.",
        "translation": "Those was my education until the fifth grade."
    },
    "158": {
        "startTime": 1181.605,
        "endTime": 1190.205,
        "transcript": "Tamaani-qaa elitnauqerraallerpeceńi elitnauristet Yugtun qancaunritellruaci wall'u-qaa qaillun qanercetaallruaceci-qaa?",
        "translation": "Back when you first started learning, were you not asked to speak, or to speak in Yup'ik?"
    },
    "159": {
        "startTime": 1190.222,
        "endTime": 1194.455,
        "transcript": "Aren, qanqaunritellruyaaqaakut",
        "translation": "Oh my, they told us not to speak [Yup'ik]"
    },
    "160": {
        "startTime": 1194.457,
        "endTime": 1199.28,
        "transcript": "Wangkuta qitevvneq nalluamteggu niicugnillrunritaput.",
        "translation": "Since we didn't know English, we didn't listen to them."
    },
    "161": {
        "startTime": 1202.139,
        "endTime": 1205.15,
        "transcript": "Qitevteqtarararangluci-llu-qaa:",
        "translation": "So did you start speaking English?"
    },
    "162": {
        "startTime": 1205.164,
        "endTime": 1213.631,
        "transcript": "Ii-i, tua-i-ll' pinginanemteńi wangkutnek, wangkutnun piyaurrngamta, elitnauristem-llu qanrutaqatkut taringyaurrrluku",
        "translation": "And as we went, when we started [speaking amongst] ourselves, and we started understand when the teacher spoke to us."
    },
    "163": {
        "startTime": 1213.636,
        "endTime": 1218.492,
        "transcript": "Wangkuta-llu ellii qaneqtararaucaurrluku.",
        "translation": "And we also started speaking to them."
    },
    "164": {
        "startTime": 1218.506,
        "endTime": 1223.306,
        "transcript": "Allat tamaa-i Kaatulit-llu pavani Kuigpagmiut waten qanlartut maa-i",
        "translation": "Others, even the Catholics up on the Yukon, say this now"
    },
    "165": {
        "startTime": 1223.318,
        "endTime": 1231.07,
        "transcript": "Tamaani ellait elitnauryukarraallratni anucimirqecetaaraqluki-llu-gguq Yugtun qanraqata.",
        "translation": "Back when they first went to school, they said they'd be punished when speaking Yup'ik."
    },
    "166": {
        "startTime": 1231.08,
        "endTime": 1233.513,
        "transcript": "Qaillun elpeci pilallruicecei?",
        "translation": "What did they do to you?"
    },
    "167": {
        "startTime": 1233.55,
        "endTime": 1240.572,
        "transcript": "Wangkuta anucimirqcetaayuitaakut, Yugtun wangkutnun qalarutengramta.",
        "translation": "They wouldn't punish us even if we spoke Yup'ik to each other."
    },
    "168": {
        "startTime": 1241.129,
        "endTime": 1253.356,
        "transcript": "Tau͡gaam tua-i qanerluci Kass'atun elitnaurtuci. You, all the school boys and girls, speak English, not Eskimo language.",
        "translation": "But you are speaking English as you go to school. You, all the school boys and girls, speak English, not Eskimo language."
    },
    "169": {
        "startTime": 1253.425,
        "endTime": 1256.8,
        "transcript": "Wangkuta qaneryaraqngamteggu",
        "translation": "Since it's our language."
    },
    "170": {
        "startTime": 1256.807,
        "endTime": 1263.215,
        "transcript": "Tamakut qanlallri elitnauristem wii man'a call' tekilluku umyuaqelaranka.",
        "translation": "I still remember what that teacher said to this day."
    },
    "171": {
        "startTime": 1263.796,
        "endTime": 1266.088,
        "transcript": "Ii-i, quyana wani qanemcilluta.",
        "translation": "Okay, thank you for telling us the stories."
    },
    "172": {
        "startTime": 1266.094,
        "endTime": 1267.644,
        "transcript": "Aa-ang.",
        "translation": "You're welcome."
    },
    "173": {
        "startTime": 1267.65,
        "endTime": 1270.917,
        "transcript": "[?] uani Napaskiarmi cali ilakaat.",
        "translation": "They're also related to [?] in Napaskiak downriver."
    },
    "174": {
        "startTime": 1270.929,
        "endTime": 1277.354,
        "transcript": "Tua-i ugna Paul Guy-aaq ugkut Guy-at ugkut uani tutga'rqanka Napaskiarmi.",
        "translation": "Paul Guy, the Guy family downriver in Napaskiak are my grandchildren."
    },
    "175": {
        "startTime": 1277.363,
        "endTime": 1279.78,
        "transcript": "Atii tau͡gaam wii yuk'aqa.",
        "translation": "But his father is my child."
    },
    "176": {
        "startTime": 1281.105,
        "endTime": 1284.122,
        "transcript": "And Andrew Guy-aq-llu au͡gna tutgarqelluku?",
        "translation": "And Andrew Guy is your grandchild?"
    },
    "177": {
        "startTime": 1284.13,
        "endTime": 1285.989,
        "transcript": "Ii-i, tutgarqelluku.",
        "translation": "Yes, he's my grandchild."
    },
    "178": {
        "startTime": 1285.997,
        "endTime": 1287.164,
        "transcript": "Nallunricaaqaqa.",
        "translation": "I do know him."
    },
    "179": {
        "startTime": 1287.168,
        "endTime": 1288.285,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "180": {
        "startTime": 1288.989,
        "endTime": 1293.022,
        "transcript": "Uumi-llu... eleven-aarulliniluteng tutgaraten.",
        "translation": "And recently... so, you have eleven grandchildren."
    },
    "181": {
        "startTime": 1293.026,
        "endTime": 1294.351,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "182": {
        "startTime": 1294.739,
        "endTime": 1301.414,
        "transcript": "Phillip Guy-am irniari, amaqlian-llu irniari waten",
        "translation": "Phillip Guy's children, and his older brother's childre like this"
    },
    "183": {
        "startTime": 1303.296,
        "endTime": 1309.304,
        "transcript": "Twelve-aarullruyaaqut. Six-aaqetaarlutek tamarmek yungqerrsaaquk.",
        "translation": "There were 12. They both have six children each."
    },
    "184": {
        "startTime": 1309.309,
        "endTime": 1314.909,
        "transcript": "Tau͡gaam amaqlian yua atauciq allragni yuunrillruuq.",
        "translation": "But one of the children of the older brother passed away last year."
    },
    "185": {
        "startTime": 1314.923,
        "endTime": 1317.514,
        "transcript": "Iluperangeksaituten-qaa?",
        "translation": "Have you not gotten any great-grandchildren yet?"
    },
    "186": {
        "startTime": 1317.809,
        "endTime": 1320.968,
        "transcript": "Iluperangeksaitevkenii.",
        "translation": "I did get great-grandchildren."
    },
    "187": {
        "startTime": 1321.326,
        "endTime": 1326.035,
        "transcript": "Iluperangqerrlua waniwa. Qavcinek ima tam' iluperangqellrianga?",
        "translation": "I have great-grandchildren. How many great-grandchildren do I have again?"
    },
    "188": {
        "startTime": 1326.049,
        "endTime": 1330.208,
        "transcript": "Atam Kiarrngualuk",
        "translation": "You see, Kiarrngualuk"
    },
    "189": {
        "startTime": 1334.154,
        "endTime": 1338.587,
        "transcript": "Au͡gna-wa kinguqliq...",
        "translation": "Then the younger one..."
    }
};